import api from "@/api/axios.js";

export const listUsers = (q) =>
	api.get("/api/users", {params: q ? {q} : {}}).then(r => r.data.users);

export const getUser = (id) =>
	api.get(`/api/users/${id}`).then(r => r.data.user);

export const createUser = (payload) =>
	api.post("/api/users", payload).then(r => r.data.user);

// Ritorna {user, cascade}: cascade.deactivated segnala sottoposti disattivati a catena
// (rimasti senza voci a menu in comune) — vedi UserFormModal per l'avviso in UI.
export const updateUser = (id, payload) =>
	api.patch(`/api/users/${id}`, payload).then(r => r.data);

export const deactivateUser = (id) =>
	api.patch(`/api/users/${id}/deactivate`).then(r => r.data.user);

export const activateUser = (id, payload) =>
	api.patch(`/api/users/${id}/activate`, payload || {}).then(r => r.data.user);

export const getCatalog = () =>
	api.get("/api/auth/menu-catalog").then(r => r.data);
